// extracted by mini-css-extract-plugin
export var contentShow = "CookiePreferencesModal-module--contentShow--2f934";
export var cookieOptions = "CookiePreferencesModal-module--cookieOptions--5232d";
export var dialogButtons = "CookiePreferencesModal-module--dialogButtons--c416f";
export var dialogClose = "CookiePreferencesModal-module--dialogClose--e04c0";
export var dialogContent = "CookiePreferencesModal-module--dialogContent--7fde0";
export var dialogDescription = "CookiePreferencesModal-module--dialogDescription--c8cf5";
export var dialogOverlay = "CookiePreferencesModal-module--dialogOverlay--13318";
export var dialogTitle = "CookiePreferencesModal-module--dialogTitle--92cd2";
export var disabled = "CookiePreferencesModal-module--disabled--9277d";
export var option = "CookiePreferencesModal-module--option--e593b";
export var optionHeader = "CookiePreferencesModal-module--optionHeader--308b1";
export var overlayShow = "CookiePreferencesModal-module--overlayShow--2bb8d";
export var switchRoot = "CookiePreferencesModal-module--switchRoot--0df5a";
export var switchThumb = "CookiePreferencesModal-module--switchThumb--7ee15";
export var switchWrapper = "CookiePreferencesModal-module--switchWrapper--13bfa";